<script lang="ts">
import {Component, Vue} from "vue-facing-decorator";
import ProjectPreviewList from "@/component/ProjectPreviewList.vue";
import NavBar from "@/component/common/NavBar.vue";

@Component({
  components: {
    NavBar,
    ProjectPreviewList
  },
})
export default class ProjectsView extends Vue {
}
</script>

<template>
  <NavBar/>
  <main class="projects-main">
    <project-preview-list/>
  </main>
</template>

<style scoped>
.projects-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: transparent;
  height: calc(100vh - var(--ln-nav-offset));
  overflow: hidden;
}
</style>
